/**
 * Full ABI for PayoutExecutor.
 * See nft-codebase/contracts/PayoutExecutor.sol
 */
const PayoutExecutorABI = [
  {
    inputs: [{ internalType: 'address', name: '_splitterAddress', type: 'address' }],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'splitter',
    outputs: [{ internalType: 'contract RevenueSplitter', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'totalAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'version', type: 'uint256' },
      { internalType: 'address[]', name: 'lpHolders', type: 'address[]' },
      { internalType: 'address', name: 'daoTreasury', type: 'address' },
      { internalType: 'address', name: 'platformTreasury', type: 'address' },
    ],
    name: 'calculatePayout',
    outputs: [
      { internalType: 'address[]', name: 'recipients', type: 'address[]' },
      { internalType: 'uint256[]', name: 'amounts', type: 'uint256[]' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
];

export default PayoutExecutorABI;
export { PayoutExecutorABI };
